import { OverlayTrigger, Popover } from 'react-bootstrap';
import { IAdresse } from 'components/AddressTypeahead/types';
import {
  KILDE_LABELS,
  buildKildeLink,
} from 'services/KjederegisteretAdminApi/EnhetKildeApi/constants';

interface Candidate {
  kilde: string;
  eksternId: string;
  adresse: IAdresse;
}

interface Props {
  currentAdresse?: IAdresse;
  candidates: Candidate[];
  onUseAddress: (adresse: IAdresse) => void;
}

const normalize = (s: string | undefined) => (s || '').trim().toUpperCase();

const matchesCurrent = (adresse: IAdresse, current?: IAdresse) =>
  !!current &&
  normalize(adresse.gateadresse) === normalize(current.gateadresse) &&
  normalize(adresse.postnr) === normalize(current.postnr) &&
  normalize(adresse.poststed) === normalize(current.poststed);

const AddressSourcesPopover = (props: Props) => {
  if (props.candidates.length === 0) return null;

  const allMatch = props.candidates.every((c) => matchesCurrent(c.adresse, props.currentAdresse));
  const badgeVariant = allMatch ? 'success' : 'warning';

  return (
    <OverlayTrigger
      trigger="click"
      placement="right"
      rootClose
      overlay={
        <Popover>
          <Popover.Header>Adresser fra kilder</Popover.Header>
          <Popover.Body>
            {props.candidates.map((c) => {
              const matches = matchesCurrent(c.adresse, props.currentAdresse);
              const sourceLink = buildKildeLink(c.kilde, c.eksternId);
              return (
                <div key={c.kilde} className="mb-2">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      props.onUseAddress(c.adresse);
                    }}
                  >
                    {c.adresse.formattedForOneLine}
                  </a>
                  <br />
                  <small className={matches ? 'text-success' : 'text-warning'}>
                    {KILDE_LABELS[c.kilde] ?? c.kilde} {matches ? '(samsvarer)' : '(avviker)'}
                  </small>
                  {sourceLink && (
                    <>
                      {' '}
                      <a
                        href={sourceLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-muted"
                        title="Åpne kilden"
                      >
                        <small>↗</small>
                      </a>
                    </>
                  )}
                </div>
              );
            })}
          </Popover.Body>
        </Popover>
      }
    >
      <span
        role="button"
        className={`badge rounded-pill bg-${badgeVariant} ms-1`}
        style={{ cursor: 'pointer', fontSize: '0.7em', verticalAlign: 'middle' }}
      >
        {props.candidates.length} {props.candidates.length === 1 ? 'kilde' : 'kilder'}
      </span>
    </OverlayTrigger>
  );
};

export default AddressSourcesPopover;
